export default "__VITE_ASSET__BFl7iQT1__"